import { render, staticRenderFns } from "./memoUpdate.vue?vue&type=template&id=01a73d9e&"
import script from "./memoUpdate.vue?vue&type=script&lang=js&"
export * from "./memoUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports